import router from '@/router';
import { SettingType } from "./common";
import { SysSetting } from "./modules";

export const checkRef = (that: any, ref: string, cb: Function) => {
    setTimeout(() => {
        if (that.$refs[ref]) {
            return cb();
        }
        checkRef(that, ref, cb);
    })
}
export const setLayout = (heightdtb: number, callback: any) => {
    let $desktop_height, $header_height;
    $desktop_height = window.innerHeight;
    $header_height = document.getElementsByClassName('header-container')[0].clientHeight;
    return callback($desktop_height - $header_height - heightdtb);
}
export const onlyNumberStr = (value: any): string => {
    return value ? `${value}`.replace(new RegExp("\\.", "gi"), "").replace(/[^0-9]/g, "") : '0';
}

// export const setLayout = (heightdtb: number, callback: any) => {
//     let $desktop_height, $header_height;
//     $desktop_height = window.innerHeight;
//     $header_height = document.getElementsByClassName('header-container')[0].clientHeight;
//     return callback($desktop_height - $header_height - heightdtb);
// }

export const removeAccents = (str: string): string => {
    if (!str) {
        return '';
    }
    var AccentsMap = [
        "aàảãáạăằẳẵắặâầẩẫấậ",
        "AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ",
        "dđ", "DĐ",
        "eèẻẽéẹêềểễếệ",
        "EÈẺẼÉẸÊỀỂỄẾỆ",
        "iìỉĩíị",
        "IÌỈĨÍỊ",
        "oòỏõóọôồổỗốộơờởỡớợ",
        "OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ",
        "uùủũúụưừửữứự",
        "UÙỦŨÚỤƯỪỬỮỨỰ",
        "yỳỷỹýỵ",
        "YỲỶỸÝỴ"
    ];
    for (var i = 0; i < AccentsMap.length; i++) {
        var re = new RegExp('[' + AccentsMap[i].substr(1) + ']', 'g');
        var char = AccentsMap[i][0];
        str = str.replace(re, char);
    }
    return str = str.replace(/\s+/g, '-').toLowerCase();
}

export const removeLink = (str: string): string => {
    var index = str.lastIndexOf("/");
    return str = str.slice(index + 1);
}

export const removeHtml = (str: string): string => {
    var lastIn = str.lastIndexOf("</p>");
    var index = str.indexOf(">")
    return str = str.substring(index + 1, lastIn);
}

export const setChecked = (t: string) => {
    const el: any = document.getElementById(t);
    if (el) {
        el.checked = !0;
    }
}

export const storeRequest = (t: any) => {
    t = JSON.parse(JSON.stringify(t));
    if (!t.content) {
        delete t["content"];
    }
    delete t.website_id;
    delete t.store_id;
    return router.push({ query: { ...router.currentRoute.value.query, ...{ request: JSON.stringify(t) } } });
}

export const mountQuery = (): any => {
    return router.currentRoute.value.query;
}

export const back = () => {
    if (history.state.back) {
        return router.back();
    }
    return router.push(router.currentRoute.value.matched[router.currentRoute.value.matched.length - 2].path);
}

export const manualCopy = (target: string): boolean => {
    if (!target) {
        return false;
    }
    const textField = document.createElement("textarea");
    textField.innerText = target;
    document.body.appendChild(textField);
    textField.select();
    textField.focus();
    document.execCommand("copy");
    textField.remove();
    return true;
};